module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/modal-close-icon-2-f986a15c6784734e92d6065ed5e9cc41.svg";